declare namespace $ {

	type $mol_button_minor__title_shm_service_filter_panel_1 = $mol_type_enforce<
		ReturnType< $shm_service_filter_panel['reset_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_service_filter_panel_2 = $mol_type_enforce<
		ReturnType< $shm_service_filter_panel['reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_list__rows_shm_service_filter_panel_3 = $mol_type_enforce<
		ReturnType< $shm_service_filter_panel['filter_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $shm_service_filter_panel extends $mol_page {
		reset( next?: any ): any
		Filter_reset( ): $mol_button_minor
		Filters( ): $mol_list
		title( ): string
		reset_title( ): string
		filter_rows( ): readonly($mol_view)[]
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=panel.view.tree.d.ts.map